import { useEffect } from 'react'

import { $getNodeByKey } from 'lexical'

import { GenericalRecord } from '@eastcoal/common/types/utilities'
import { pick } from '@eastcoal/common/utils/object'

import { isEqualState } from '../../utils/state'
import { useEditor } from '../useEditor'

import { UseSyncNodeStateProps } from './interface'

export const useSyncNodeState = <
  U extends GenericalRecord,
  N extends GenericalRecord
>({
  nodeKey,
  stateKeys,
  subscribe,
  isTargetNode
}: UseSyncNodeStateProps<U, N>) => {
  const editor = useEditor()

  useEffect(() => {
    return subscribe(uiState => {
      editor.update(() => {
        const node = $getNodeByKey(nodeKey)
        if (!isTargetNode(node)) {
          return
        }
        const nodeState = node.getState()
        if (isEqualState(uiState, nodeState, stateKeys)) {
          return
        }
        node.setState(pick(uiState, stateKeys) as N)
      })
    })
  }, [editor, nodeKey, stateKeys, subscribe, isTargetNode])
}
